import { checked, warning } from "assets/icons";
import {
  AppTable,
  AppModal,
  FormInput,
  AppButton,
  FormSelect,
  SearchInput,
  Skeleton,
} from "components";
import { TableBodyContent } from "components/AppTable";
import Administrator from "components/Administrator";
import DashboardLayout from "layouts/DashboardLayout";
import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useSearchParams } from "react-router-dom";
import { ApiService } from "services";
import styled from "styled-components";
import moment from "moment";
import { Router } from "utils/route";
import InstitutionDetails from "components/InstitutionDetails";
import InstitutionUsers from "components/InstitutionUsers";
import InstitutionTransactions from "components/InstitutionTransactions";
import { AiOutlineArrowLeft } from "react-icons/ai";
import axios from "axios";
import Skeleton2 from "components/Skeleton2";
import { userData } from "utils/userData";
import { handleCheckMetric } from "utils/handleMetricsChekc";
export default function InstitutionDetailsPage() {
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);

  const [loading4, setLoading4] = useState(false);
  const [loading5, setLoading5] = useState(false);
  const [loading6, setLoading6] = useState(false);
  const [loading7, setLoading7] = useState(false);
  const [loading8, setLoading8] = useState(false);
  const [loading9, setLoading9] = useState(false);
  const [loading10, setLoading10] = useState(false);

  const [code2, setCode2] = useState();

  //eslint-disable-next-line
  const [configFilterRate, setConfigFilterRate] = useState();
  //eslint-disable-next-line
  const [configFilterTime, setConfigFilterTime] = useState();

  const [institutionDetails, setInstitutionDetails] = useState(false);
  const [boundType, setBoundType] = useState("inbound");
  const savedItems = JSON.parse(localStorage.getItem("sInst"));

  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "multipart/form-data",
    },
  };

  const [inst, setInst] = useState();
  const getInstitution = async (id) => {
    setLoading(true);

    try {
      const data = await ApiService.getInstitution(id);
      console.log(data, "inst");
      setViewAdmin(true);
      setInst(data);
      setLoading(false);
      console.log(data);
    } catch (err) {
      setLoading(false);
      console.log(err);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
    }
  };
  const getInstitution2 = async (id) => {
    setLoading(true);

    try {
      const data = await ApiService.getInstitution(id);
      console.log(data, "inst");
      setViewInstitution(true);
      setInst(data);
      setLoading(false);
      console.log(data);
    } catch (err) {
      setLoading(false);
      console.log(err);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
    }
  };

  const [dataDashboard, setDataDashboard] = useState();
  const [dataDashboard4, setDataDashboard4] = useState();
  const [dataDashboard5, setDataDashboard5] = useState();
  const [dataDashboard6, setDataDashboard6] = useState();
  const [dataDashboard7, setDataDashboard7] = useState();
  const [dataDashboard8, setDataDashboard8] = useState();
  const [dataDashboard9, setDataDashboard9] = useState();
  const [dataDashboard10, setDataDashboard10] = useState();
  const [searchInput, setSearchInput] = useState("");

  const getInstitutionss = async (id) => {
    setLoading2(true);
    setInstitutionDetails(true);

    try {
      const data = await ApiService.getInstitutionDashboard(id);
      setLoading2(false);
      setDataDashboard(data);
      console.log(data);
    } catch (err) {
      console.log(err);
      setLoading2(false);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
    }
  };

  const getInstitutionss4 = async (id) => {
    setLoading4(true);

    try {
      const data = await ApiService.getInstitutionDashboard(id);
      setLoading4(false);
      setDataDashboard4(data);
      console.log(data);
    } catch (err) {
      console.log(err);
      setLoading4(false);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
    }
  };

  const getInstitutionss5 = async (id) => {
    setLoading5(true);

    try {
      const data = await ApiService.getInstitutionDashboard(id);
      setLoading5(false);
      setDataDashboard5(data);
      console.log(data);
    } catch (err) {
      console.log(err);
      setLoading5(false);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
    }
  };

  const getInstitutionss6 = async (id) => {
    setLoading6(true);

    try {
      const data = await ApiService.getInstitutionDashboard(id);
      setLoading6(false);
      setDataDashboard6(data);
      console.log(data);
    } catch (err) {
      console.log(err);
      setLoading6(false);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
    }
  };

  const getInstitutionss7 = async (id) => {
    setLoading7(true);

    try {
      const data = await ApiService.getInstitutionDashboard(id);
      setLoading7(false);
      setDataDashboard7(data);
      console.log(data);
    } catch (err) {
      console.log(err);
      setLoading7(false);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
    }
  };

  const getInstitutionss8 = async (id) => {
    setLoading8(true);

    try {
      const data = await ApiService.getInstitutionDashboard(id);
      setLoading8(false);
      setDataDashboard8(data);
      console.log(data);
    } catch (err) {
      console.log(err);
      setLoading8(false);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
    }
  };

  const getInstitutionss9 = async (id) => {
    setLoading9(true);

    try {
      const data = await ApiService.getInstitutionDashboard(id);
      setLoading9(false);
      setDataDashboard9(data);
      console.log(data);
    } catch (err) {
      console.log(err);
      setLoading9(false);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
    }
  };
  const getInstitutionss10 = async (id) => {
    setLoading10(true);

    try {
      const data = await ApiService.getInstitutionDashboard(id);
      setLoading10(false);
      setDataDashboard10(data);
      console.log(data);
    } catch (err) {
      console.log(err);
      setLoading10(false);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
    }
  };
  console.log(dataDashboard);

  const { route } = Router();
  //eslint-disable-next-line
  const [viewAdmin, setViewAdmin] = useState(false);
  const [viewInstitution, setViewInstitution] = useState(false);
  const [selected, setSelected] = useState();

  const [seconds, setSeconds] = useState(300);

  console.log(selected);
  const [param] = useSearchParams();
  const activeTab = param.get("tab");
  const details = param.get("details");
  const codeUser = param.get("code");

  console.log(selected);
  const boundin = boundType;
  const idin = details;

  console.log(boundin, idin, savedItems, "new");

  useEffect(() => {
    const interval = setInterval(() => {
      if (
        userData?.userDetail?.role === "chiefAdmin" ||
        userData?.userDetail?.role === "subAdmin1" ||
        userData?.userDetail?.role === "subAdmin2"
      ) {
        if (
          handleCheckMetric("todayTransaction", userData?.userDetail?.metrics)
        ) {
          getInstitutionss6(
            `/${idin}?direction=${
              boundType === "inbound" ? "outbound" : "inbound"
            }&indicatorLastPeriod=${seconds}&reportType=adminUsers`
          );
        }
      }
    }, 15 * 1000);
    return () => clearInterval(interval);

    //eslint-disable-next-line
  }, []);

  return (
    <div
      onClick={() => {
        setSelected("");
      }}
    >
      <DashboardLayout>
        <>
          <InstitutionDetails
            //showTransactions={setViewTransactions}
            data={dataDashboard}
            data4={dataDashboard4}
            data5={dataDashboard5}
            data6={dataDashboard6}
            data7={dataDashboard7}
            data8={dataDashboard8}
            data9={dataDashboard9}
            data10={dataDashboard10}
            close={setInstitutionDetails}
            setCode={setCode2}
            boundType={boundType}
            setBoundType={setBoundType}
            seconds={seconds}
            setSeconds={setSeconds}
            callMain={getInstitutionss}
            callMain4={getInstitutionss4}
            callMain5={getInstitutionss5}
            callMain6={getInstitutionss6}
            callMain7={getInstitutionss7}
            callMain8={getInstitutionss8}
            callMain9={getInstitutionss9}
            callMain10={getInstitutionss10}
            loading={loading2}
            loading4={loading4}
            loading6={loading6}
            loading5={loading5}
            loading7={loading7}
            loading8={loading8}
            loading9={loading9}
            loading10={loading10}
            id={details}
            callBound={() => {
              getInstitutionss(
                `/${details}?direction=${
                  boundType === "inbound" ? "outbound" : "inbound"
                }&indicatorLastPeriod=${seconds}&reportType=indicator`
              );

              getInstitutionss4(
                `/${details}?direction=${
                  boundType === "inbound" ? "outbound" : "inbound"
                }&indicatorLastPeriod=${seconds}&reportType=approvalRate`
              );

              getInstitutionss5(
                `/${details}?direction=${
                  boundType === "inbound" ? "outbound" : "inbound"
                }&indicatorLastPeriod=${seconds}&reportType=adminUsers`
              );
              getInstitutionss6(
                `/${details}?direction=${
                  boundType === "inbound" ? "outbound" : "inbound"
                }&indicatorLastPeriod=${seconds}&reportType=adminUsers`
              );

              getInstitutionss7(
                `/${details}?direction=${
                  boundType === "inbound" ? "outbound" : "inbound"
                }&indicatorLastPeriod=${seconds}&reportType=recentBanks`
              );

              getInstitutionss8(
                `/${details}?direction=${
                  boundType === "inbound" ? "outbound" : "inbound"
                }&indicatorLastPeriod=${seconds}&reportType=adminUsers`
              );

              getInstitutionss9(
                `/${details}?direction=${
                  boundType === "inbound" ? "outbound" : "inbound"
                }&indicatorLastPeriod=${seconds}&reportType=transactionPerformance`
              );

              getInstitutionss10(
                `/${details}?direction=${
                  boundType === "inbound" ? "outbound" : "inbound"
                }&indicatorLastPeriod=${seconds}&reportType=transaction`
              );
            }}
          />

          <>
            <p
              onClick={() => route(`/institutions?tab=${activeTab}`)}
              style={{
                color: "#14A2FD",
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <AiOutlineArrowLeft size={20} style={{ marginRight: "10px" }} />{" "}
              Back
            </p>
            <InstitutionTransactions id={idin} />
          </>
        </>
      </DashboardLayout>
    </div>
  );
}

const ViewAdmin = styled.div`
  background: #1b59f81c;
  color: #1b59f8;
  padding: 10px;
  border-radius: 6px;
  cursor: pointer;
  width: fit-content;
  display: flex;
  align-items: center;
  position: relative;
  font-size: 11px;

  .dropdown {
    position: absolute;
    border: 1px solid #e1e1e1;
    border-radius: 20px;
    right: 0;
    background-color: white;
    z-index: 100;
    padding: 6px 16px;
    width: 160%;
    text-transform: capitalize;
    font-size: 14px;
    z-index: 120;
    .title {
      color: #000000b2;
      font-weight: 600;
      border-bottom: 1px solid #0000001a;
      padding: 6px 4px;
    }

    .item {
      padding: 6px 4px;
      cursor: pointer;
      color: #000000;
      font-weight: 4300;
    }
  }
`;
